import React from 'react';
import VideoPlayer from './VideoPlayer';

export default function IPhoneMockup({ videoUrl, bgColor }) {
  if (!videoUrl) return null;

  return (
    <div className="px-7 md:px-24 mb-24 md:mb-40 mt-24 md:mt-40 flex justify-center w-full">
      <div className="relative w-full max-w-8xl flex justify-center items-center py-16 md:py-24">
        
        <div 
          className="absolute inset-0 hidden md:block" 
          style={{ backgroundColor: bgColor || '#e5e7eb' }}
        />

        <div className="relative z-10 w-full max-w-75 md:max-w-90 flex flex-col items-center">
          <div className="relative w-full p-0.5 md:p-1 bg-linear-to-br from-[#5E5E60] via-[#2C2C2E] to-[#5E5E60] rounded-[3rem] md:rounded-[3.5rem] shadow-[0_30px_60px_-15px_rgba(0,0,0,0.8)] z-20 flex flex-col">
            <div className="absolute top-[15%] -left-0.5 md:-left-0.75 w-0.5 md:w-0.75 h-6 md:h-8 bg-[#4A4A4C] rounded-l-md z-10 shadow-[inset_1px_0_1px_rgba(255,255,255,0.2)]"></div>
            <div className="absolute top-[22%] -left-0.5 md:-left-0.75 w-0.5 md:w-0.75 h-12 md:h-16 bg-[#4A4A4C] rounded-l-md z-10 shadow-[inset_1px_0_1px_rgba(255,255,255,0.2)]"></div>
            <div className="absolute top-[31%] -left-0.5 md:-left-0.75 w-0.5 md:w-0.75 h-12 md:h-16 bg-[#4A4A4C] rounded-l-md z-10 shadow-[inset_1px_0_1px_rgba(255,255,255,0.2)]"></div>
            <div className="absolute top-[25%] -right-0.5 md:-right-0.75 w-0.5 md:w-0.75 h-16 md:h-20 bg-[#4A4A4C] rounded-r-md z-10 shadow-[inset_-1px_0_1px_rgba(255,255,255,0.2)]"></div>

            <div className="relative w-full bg-black p-1.5 md:p-2.5 rounded-[calc(3rem-2px)] md:rounded-[calc(3.5rem-4px)] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.15)]">
              <div className="relative w-full aspect-9/19.5 bg-[#0A0A0A] rounded-[calc(3rem-8px)] md:rounded-[calc(3.5rem-14px)] overflow-hidden ring-1 ring-white/10">
                <div className="absolute top-2 md:top-3 left-1/2 -translate-x-1/2 w-[35%] max-w-30 h-6 md:h-8 bg-black rounded-full z-30 flex items-center justify-end px-2 md:px-3 shadow-[0_0_1px_rgba(255,255,255,0.1)]">
                  <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-[#111928] rounded-full border border-white/5 shadow-[inset_0_0_2px_rgba(0,0,0,0.8)] flex items-center justify-center">
                    <div className="w-0.5 h-0.5 bg-blue-500/40 rounded-full"></div>
                  </div>
                </div>

                <VideoPlayer
                  src={videoUrl}
                  className="absolute top-0 bottom-0 w-[calc(100%-16px)] h-full object-cover rounded-3xl"
                />
                
                <div className="absolute bottom-1.5 md:bottom-2 left-1/2 -translate-x-1/2 w-[35%] h-1 md:h-1.5 bg-white/80 rounded-full z-30 mix-blend-difference"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}